import React, { useEffect } from 'react';

//*Mui
import {
  Modal,
  Box,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  FormHelperText,
  InputLabel,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

//*redux
import { useDispatch } from 'react-redux';
import action from '../../Redux Store/actions';

//*files
import cssClasses from './AddCollateral.module.css';
import Close from '../../Components/Icons/Close';
import Button from '../../Subcomponents/Button';
import UploadIcon from '../../Assets/Images/Common/uploadIcon.svg';
import DateComponent from '../../Subcomponents/DateComponent';
import {
  AddProjectCollateralWithCp,
  AddProjectsCollateral,
  getAllChannelPartners,
  getProjectCollateralWithCp,
  UpdateProjectsCollateral,
  UploadCollaterals,
} from '../../Services/Project';
import { useState } from 'react';
import { useParams } from 'react-router';
import { errorTost, successTost } from '../../Services/Toast';
import { differenceWith, uniq, uniqBy } from 'lodash';
import CollateralImg from "../../Assets/Images/Common/gallery.svg";
import { dismissLoader, presentLoader } from '../../Services/loader';

const style = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: '60%',
  width: 'Fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

const useStyles = makeStyles((theme) => ({
  label: {
    fontFamily: 'Inter-Regular !important',
    fontSize: '1.6rem !important',
    lineHeight: '2.4rem !important',
    color: '#98A2B3 !important',
    background: '#F2F4F7 !important',
    fontWeight: '400 !important',
    padding: '0px !important',
    '&.Mui-focused': {
      display: 'none !important',
      color: ' #84CAFF !important',
    },
  },
  select: {
    minWidth: '15rem',
    fontFamily: 'Inter-Regular !important',
    fontSize: '1.6rem !important',
    border: '1px solid #EFF8FF !important',
    lineHeight: '2.4rem !important',
    background: '#F2F4F7 !important',
    color: '#98A2B3 !important',
    textAlign: 'left',
    overflow: 'hidden !important',
    whiteSpace: 'nowrap !important',
    textOverflow: 'ellipsis !important',
    fontWeight: '400 !important',
    //  border: "1px solid #D0D5DD !important",
    borderRadius: '0.8rem !important',
    boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
    '&.Mui-focused': {
      border: '1px solid #84CAFF !important',
      boxShadow:
        '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important',
      background: '#FFFFFF !important',
    },
    '& .MuiSelect-outlined': {},
    '& fieldSet': {
      border: 'none',
    },
    '& .MuiSelect-icon': {
      width: '2em !important',
      height: '2em !important',
      top: '0.5rem !important',
    },
    '&.Mui-error': {
      border: '1px solid red !important',
    },
    '& .MuiSelect-select': {
      // padding: "0.8rem 1.4rem !important",
      padding: '1.4rem 1.4rem !important',
    },
  },
  DropDownName: {
    margin: '0',
    ' & span': {
      fontFamily: 'Inter-Medium',
      fontSize: '1.6rem',
      lineHeight: '2.4rem',
      letterSpacing: '0.3px',
      color: '#344054',
      marginTop: '0.7rem',
      // width:"80% !important",
      marginBottom: '0.3rem !important',
      // display: 'inline-block !important',
      textAlign: 'left !important',
      overflow: 'hidden !important',
      whiteSpace: 'nowrap !important',
      textOverflow: 'ellipsis !important',
      textTransform: 'uppercase !important' ,
    },
    '&.Mui-focused': {
      border: '1px solid #84CAFF !important',
      boxShadow:
        '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important',
      background: '#FFFFFF !important',
    },
  },
}));

function AddCollateral({ open, handleClose, returnRespValue, ModalType, CollateralArray }) {
  const dispatch = useDispatch();
  const classList = useStyles();
  const [CpNames, setCpNames] = useState([]);
  const [selectedCps, setSelectedCps] = useState([]);
  const [CollateralID, setCollateralID] = useState('');
  const [fileSelected, setFileSelected] = useState(null);
  const [fileType, setFileType] = useState(false);
  const [selectedFileUpload, setSelectedFileUpload] = useState(null);
  const { projectId } = useParams();
  useEffect(() => {
    dispatch(action.activeMenu('project'));
    getChannelPartners();
  }, []);

  useEffect(() => {
    console.log('selectedCps', selectedCps);
  }, [selectedCps]);

  // useEffect(() => {
  //   if (fileSelected) {
  //     document.getElementById("ProfileImageInputRef").src =
  //       URL.createObjectURL(fileSelected);
  //   }
  // }, [fileSelected]);


  const [CollateralDetails, setCollateralDetails] = useState({
    StartDate: '',
    EndDate: '',
    cpData: [],
    Document: "",
  });

  const [HelperText, setHelperText] = useState({
    StartDate: '',
    EndDate: '',
    cpData: [],
    Document: "",
  });

  const isAllSelected =
    CpNames.length > 0 && selectedCps.length === CpNames.length;


  function getChannelPartners() {
    getAllChannelPartners()
      .then((resp) => {
        console.log('CP-Data', resp);
        setCpNames(resp.data);
      })
      .catch((err) => {
        console.log('all-Cp', err);
      });
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        overflowX: 'auto',
        '& .MuiSelected': {
          color: '#F9FAFB !important',
        },
      },
    },
    MenuListProps: {
      disablePadding: true,
    },
    background: '#F2F4F7 !important',
  };

  useEffect(() => {
    console.log({ CollateralArray });
    if (ModalType === "edit") {
      console.log("CollateralArray.collateralUrl", CollateralArray.collateralUrl)
      console.log("CollateralArray.projectCollateralId", CollateralArray.projectCollateralId)

      setSelectedCps(CollateralArray.projectCollateralId)
      setCollateralDetails((pre) => {
        pre.StartDate = CollateralArray.projectCollateralId[0].startDateTime;
        pre.EndDate = CollateralArray.projectCollateralId[0].endDateTime;
        pre.cpData = CollateralArray.projectCollateralId;
        pre.Document = CollateralArray.collateralUrl;
        return { ...pre };
      });

    }
  }, []);

  //*Uploading-Images
  async function selectFile(_file) {
    console.log(_file);
    // if(_file && _file.type.includes('image')) {
    //   setFileSelected(URL.createObjectURL(_file));
    //   setFileType(true)
    // } else {
    //   setFileType(false)
    // }
    setFileSelected(_file)

    setCollateralDetails((pre) => {
      pre.Document = _file;
      return { ...pre };
    })

    // let flag = validateCollateralData()

    // if(flag === 0) {
    //   console.log("flag completed")
    //   if(_file &&_file.type.includes('image') ) {
    //     // const ImgData = URL.createObjectURL(_file)
    //    const UpdateImg = await convertImageFileToWebpFile(_file)
    //    setCollateralDetails((pre) => {
    //     pre.Document = UpdateImg;
    //     return { ...pre };
    //   });

    //   } else {
    //     setCollateralDetails((pre) => {
    //       pre.Document = _file;
    //       return { ...pre };
    //     });
    //   }
    // }
  }

  function convertImageFileToWebpFile(file) {
    console.log('----->', file?.name?.split('.')[0]);
    return new Promise((resolve, reject) => {
      if (file.type.includes('image/')) {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;
          canvas.getContext('2d').drawImage(image, 0, 0);
          canvas.toBlob((blob) => {
            let myFile = new File([blob], `${file.name.split('.')[0]}.webp`, {
              type: blob.type,
            });
            resolve(myFile);
          }, 'image/webp');
        };
        image.onerror = (err) => {
          console.log('error in reading image: ', err);
        }
        image.crossOrigin = 'anonymous';
        image.src = URL.createObjectURL(file);
      } else {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          let myFile = new File([e.target.result], file.name, {
            type: file.type,
          });
          // let myFile = e.target.result;
          resolve(myFile);
        }
        fileReader.onerror = (err) => {
          console.log('error in reading file: ', err);
        }
        fileReader.readAsArrayBuffer(file);
      }
    });
  }

  //*Cp-Data
  const handleChange = (event) => {
    const value = event.target.value;
    console.log("value", value)
    if (value !== '') {

      if (value[value.length - 1] === 'all') {
        setSelectedCps(selectedCps.length === CpNames.length ? [] : CpNames);
        setCollateralDetails((pre) => {
          pre.cpData = selectedCps.length === CpNames.length ? [] : CpNames;
          return { ...pre };
        })
        return;
      }
      setSelectedCps(value);
      setCollateralDetails((pre) => {
        pre.cpData = value;
        return { ...pre };
      })
      console.log('---->', value);
    } else {
      console.log("something went wrong!")
    }
  };

  function validateCollateralData() {
    let ValidateFlag = 0;
    if (CollateralDetails.cpData.length === 0) {

      setHelperText((pre) => {
        pre.cpData = 'Please select Channel Partners';
        return { ...pre };
      });
      ValidateFlag = 1;
    }

    if (CollateralDetails.Document === "") {

      setHelperText((pre) => {
        pre.Document = 'Please upload documents';
        return { ...pre };
      });
      ValidateFlag = 1;
    }

    if (CollateralDetails.StartDate === '') {

      setHelperText((pre) => {
        pre.StartDate = 'Please enter start date';
        return { ...pre };
      });

      ValidateFlag = 1;
    }

    if (CollateralDetails.EndDate === '') {

      setHelperText((pre) => {
        pre.EndDate = 'Please enter end date';
        return { ...pre };
      });

      ValidateFlag = 1;
    }

    return ValidateFlag;
  }

  async function OnSubmit() {
    console.log("CollateralDetails.Document", CollateralDetails.Document)
    let flag = validateCollateralData();
    console.log("flag.flag", flag)
    console.log("CollateralDetails.cpData", CollateralDetails.cpData)
    console.log("CollateralDetails.Document", CollateralDetails.Document)
    console.log("CollateralDetails.StartDate", CollateralDetails.StartDate)
    console.log("CollateralDetails.EndDate", CollateralDetails.EndDate)

    if (ModalType === "add" && flag === 0) {
      presentLoader()
      console.log('Selected-Cps', selectedCps);
      console.log('_file', CollateralDetails.Document);
      convertImageFileToWebpFile(CollateralDetails?.Document).then((file) => {
        console.log("converted-file", file)
        // ! vedashree changes
        // const StorageImage = CollateralDetails.Document.type.includes('image') ? file : CollateralDetails.Document.name;
        // UploadCollaterals(StorageImage, projectId)
        UploadCollaterals(file, projectId)
          .then((resp) => {
            console.info('UploadCollaterals', resp);
            if (resp) {
              let obj = {
                collateralUrl: resp.data.Key,
                projectId: projectId,
              };
              AddProjectsCollateral(obj)
                .then((res) => {
                  console.info(
                    'Added-Project-Collaterals',
                    res.data[0].projectCollateralId
                  );
                  let postData = uniqBy(
                    selectedCps.map((m) => ({
                      startDateTime: new Date(CollateralDetails.StartDate).getTime(),
                      endDateTime: new Date(CollateralDetails.EndDate).getTime(),
                      cpId: m.cpId,
                      projectCollateralId: res.data[0].projectCollateralId,
                    }))
                  );
                  console.info(postData);
                  let uploadCount = 0;
                  for (let index = 0; index < postData.length; index++) {
                    const element = postData[index];
                    AddProjectCollateralWithCp(element)
                      // eslint-disable-next-line no-loop-func
                      .then((res) => {
                        console.log('Saved-Cp', res);
                        uploadCount++;
                        // ! considering index here will give incorrect o/p
                        // if (index === postData.length - 1) {
                        if (uploadCount === postData.length) {
                          //todo loader dismiss or show tost
                          dismissLoader()
                          successTost('Collateral added successfully!');
                          handleClose();
                          returnRespValue(true);
                        }
                      })
                      .catch((err) => {
                        console.log('selected-Cp-err', err);
                      });
                  }
                })
                .catch((err) => {
                  console.error('Added-Project-Collaterals-err', err);
                });
            }
          })
          .catch((err) => {
            console.error('UploadCollaterals-err', err);
          });
      })


    } else if (ModalType === "edit") {
      console.log('Selected-Cps', selectedCps);
      if (CollateralDetails.Document) {
        console.log("selectFileUpload", CollateralDetails.Document)
        //  convertImageFileToWebpFile(CollateralDetails.Document).then((file) => {
        //     console.log("file" , file)
        //     const  ImageObj  = CollateralDetails.Document.type.includes('image') ? file: CollateralDetails.Document ;
        //     console.log('_file', ImageObj);
        //     UploadCollaterals(ImageObj, projectId)
        //       .then((resp) => {
        //         console.info('UploadCollaterals', resp);
        //         if (resp) {
        //           UpdateProjectsCollateral(resp.data.Key, projectId , CollateralArray.projectCollateralId[0].projectCollateralId)
        //             .then((res) => {
        //               console.info(
        //                 'Added-Project-Collaterals',
        //                 res.data[0].projectCollateralId
        //               );
        //               selectedCps.forEach((m) => {
        //                 getProjectCollateralWithCp().then((response88) => {
        //                   // if(response88.data.length === 0) {
        //                   //   let UpdateCps = {
        //                   //     startDateTime: new Date(CollateralDetails.StartDate).getTime(),
        //                   //     endDateTime: new Date(CollateralDetails.EndDate).getTime(),
        //                   //     cpId: m.cpId,
        //                   //     projectCollateralId: CollateralArray.projectCollateralId[0].projectCollateralId,
        //                   //   }
        //                   //   AddProjectCollateralWithCp(UpdateCps).then((response99) => {
        //                   //     console.log("Didn't exist , so added" , response88)
        //                   //   }).catch((err) => {
        //                   //     console.error("AddProjectCollateralWithCp" , err)
        //                   //   })
        //                   // } else if(response88.data.length > 0) {
        //                   //   let deleteArr = differenceWith(selectedCps , )
        //                   // }
        //                 }).catch((err) => {
        //                   console.error("getProjectCollateralWithCp" , err)
        //                 })
        //               })


        //               // let postData = uniqBy(
        //               //   selectedCps.map((m) => ({
        //               //     startDateTime: new Date(CollateralDetails.StartDate).getTime(),
        //               //     endDateTime: new Date(CollateralDetails.EndDate).getTime(),
        //               //     cpId: m.cpId,
        //               //     projectCollateralId: res.data[0].projectCollateralId,
        //               //   }))
        //               // );
        //               // console.info(postData);



        //               // for (let index = 0; index < postData.length; index++) {
        //               //   const element = postData[index];
        //               //   AddProjectCollateralWithCp(element)
        //               //     .then((res) => {
        //               //       console.log('Saved-Cp', res);
        //               //       if (index === postData.length - 1) {
        //               //         //todo loader dismiss or show tost
        //               //         successTost('Collateral added successfully!');
        //               //         handleClose();
        //               //         returnRespValue(true);
        //               //       }
        //               //     })
        //               //     .catch((err) => {
        //               //       console.log('selected-Cp-err', err);
        //               //     });
        //               // }
        //             })
        //             .catch((err) => {
        //               console.error('Added-Project-Collaterals-err', err);
        //             });
        //         }
        //       })
        //       .catch((err) => {
        //         console.error('UploadCollaterals-err', err);
        //       });
        //   })
      }
    }


  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      <Box sx={style}>
        <Box className={cssClasses.headerDiv}>
          <Box className={cssClasses.flexRow}>
            <Box className={cssClasses.flexCol}>
              <Box className={cssClasses.HeaderTitle} mt={1}>
                {ModalType === "edit" ? "Edit Collateral" : "Add Collateral"}
              </Box>{' '}
            </Box>
            <Box
              ml={'auto'}
              mt={1}
              onClick={handleClose}
              style={{ cursor: 'pointer' }}
            >
              <Close width={'1.2rem'} height={'1.2rem'} />
            </Box>
          </Box>
        </Box>

        <Box width={'100%'} height={'78%'} overflow={'auto'}>
          <Box margin={'2rem 4rem'}>
            <Box className={cssClasses.flexRow}>
              <Box>
                <Box className={cssClasses.InputTitle} mt={1.5}>
                  Add Document
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <Box className={cssClasses.Container} >
                    <Box
                      style={{
                        // border: HelperText?.Document === true
                        //   ?  '1px dashed #344054'
                        //   : '1px solid #d32f2f',
                        border: '1px dashed #344054',
                      }}
                      onClick={() => {
                        document.getElementById("imgupload").click();
                      }}
                      className={cssClasses.SubContainer}
                    >

                      {CollateralDetails.Document || fileSelected ? (
                        <div className={cssClasses.uploadInputImg}>
                          {CollateralDetails?.Document?.toString().split('.').pop() === 'webp' || fileSelected?.type?.includes('image') ?
                            <>
                              <img
                                className={cssClasses.uploadedImg}
                                id="ProfileImageInputRef"
                                src={
                                  CollateralDetails.Document
                                    ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                                    CollateralDetails.Document +
                                    `?${Date.now()}`
                                    : URL.createObjectURL(fileSelected)
                                }
                                onError={(e) => { e.target.src = URL.createObjectURL(fileSelected) }}
                                alt=""
                              />
                            </>
                            : <Box className={cssClasses.UploadTitle}> {(CollateralDetails?.Document && typeof (CollateralDetails?.Document) === "string") ? CollateralDetails?.Document?.split('/')[2] : fileSelected?.name}</Box>
                          }


                          <input
                            hidden
                            type="file"
                            accept='image/*,.pdf , .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document , video/*'
                            id="imgupload"
                            name=""
                            onChange={async (e) => {
                              selectFile(e.target.files[0])
                              setHelperText((pre) => {
                                pre.Document = "";
                                return { ...pre };
                              })
                              // setFileSelected(e.target.files[0]);
                              // console.log("e.target.files" , e.target.files[0])
                              // if(e.target.files[0].type.includes('image')) {
                              //   // const ImgData = URL.createObjectURL(e.target.files[0])
                              //  const UpdateImg = await convertImageFileToWebpFile(e.target.files[0])
                              //  setCollateralDetails((pre) => {
                              //   pre.Document = UpdateImg;
                              //   return { ...pre };
                              // });
                              // setHelperText((pre) => {
                              //   pre.Document = true;

                              //   return {...pre};
                              // })
                              // } else {
                              //   setCollateralDetails((pre) => {
                              //     pre.Document = e.target.files[0];
                              //     return { ...pre };
                              //   });
                              //   setHelperText((pre) => {
                              //     pre.Document = true;
                              //     return {...pre};
                              //   })
                              // }

                            }}
                          />
                          {/* Small icon upload image here */}
                          <div className={cssClasses.reupload}>
                            <div className={cssClasses.uploadImg1}>
                              <img src={CollateralImg} alt="" />
                            </div>
                            <div className={cssClasses.uplaodLabel1}>
                              <p>Upload here</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={cssClasses.uploadInput}>
                          <div className={cssClasses.uploadImg}>
                            <img src={CollateralImg} alt="" />
                          </div>
                          <div className={cssClasses.uplaodLabel}>
                            <p>Upload here</p>
                          </div>
                          <input
                            hidden
                            type="file"
                            accept='image/*,.pdf , .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document , video/*'
                            id="imgupload"
                            name=""
                            onChange={async (e) => {
                              selectFile(e.target.files[0])
                              setHelperText((pre) => {
                                pre.Document = "";
                                return { ...pre };
                              })
                              // setFileSelected(e.target.files[0]);
                              // console.log("e.target.files" , e.target.files[0])
                              // if(e.target.files[0].type.includes('image')) {
                              //   // const ImgData = URL.createObjectURL(e.target.files[0])
                              //  const UpdateImg = await convertImageFileToWebpFile(e.target.files[0])
                              //  setCollateralDetails((pre) => {
                              //   pre.Document = UpdateImg;
                              //   return { ...pre };
                              // });
                              // setHelperText((pre) => {
                              //   pre.Document = true;
                              //   return {...pre};
                              // })
                              // } else {
                              //   setCollateralDetails((pre) => {
                              //     pre.Document = e.target.files[0];
                              //     return { ...pre };
                              //   });
                              //   setHelperText((pre) => {
                              //     pre.Document = true;
                              //     return {...pre};
                              //   })
                              // }
                              // setFileSelected(e.target.files[0]);
                            }}
                          />
                        </div>
                      )}
                    </Box>
                  </Box>
                  {HelperText?.Document && (
                    <p
                      style={{
                        color: '#d32f2f',
                        fontSize: '1.4rem',
                        marginLeft: '1rem',
                      }}
                    >
                      {HelperText.Document}
                    </p>
                  )}
                </Box>
              </Box>

              <Box>
                <Box className={cssClasses.InputTitle} mt={1.5}>
                  Start Date
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox} mt={2}>
                  <DateComponent
                    value={CollateralDetails.StartDate}
                    onChangeDate={(_value) => {
                      console.log('Start-Date', _value);
                      setCollateralDetails((pre) => {
                        pre.StartDate = _value;
                        return { ...pre };
                      });
                      setHelperText((pre) => {
                        pre.StartDate = '';
                        return { ...pre };
                      });
                    }}
                    helperText={HelperText.StartDate}
                  />
                </Box>
                <Box className={cssClasses.InputTitle} mt={2.5}>
                  End Date
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox} mt={2}>
                  <DateComponent
                    value={CollateralDetails.EndDate}
                    onChangeDate={(_value) => {
                      console.log('End-Date', _value);
                      setCollateralDetails((pre) => {
                        pre.EndDate = _value;
                        return { ...pre };
                      });
                      setHelperText((pre) => {
                        pre.EndDate = '';
                        return { ...pre };
                      });
                      if (CollateralDetails.StartDate > _value) {
                        setHelperText((pre) => {
                          pre.EndDate = "Select end date greater than start date";
                          return { ...pre };
                        })
                      }
                    }}
                    helperText={HelperText.EndDate}
                  />
                </Box>
              </Box>
            </Box>

            <Box>
              <Box className={cssClasses.InputTitle} mt={1.5}>
                Select CP
                <span className={cssClasses.Star}>*</span>
              </Box>
              <Box mt={1}>
                <FormControl
                  sx={{ width: '30rem' }}
                // error={!HelperText.cpData}
                >
                  {selectedCps === '' ? (
                    <InputLabel
                      id='demo-simple-select-label'
                      className={classList.label}
                      sx={[
                        {
                          color: '#667085 !important',
                          background: '#F2F4F7 !important',
                        },
                      ]}
                    >
                      {selectedCps}
                    </InputLabel>
                  ) : (
                    ''
                  )}
                  <Select
                    labelId='demo-multiple-checkbox-label'
                    id='demo-multiple-checkbox'
                    multiple
                    className={classList.select}
                    value={selectedCps}
                    sx={[
                      {
                        color: '#D0D5DD',
                        background: ' #F2F4F7  !important',
                        '& .MuiList-root-MuiMenu-list': {
                          maxWidth: '25% !important',
                          '& .MuiButtonBase-root-MuiMenuItem-root.Mui-selected':
                          {
                            backgroundColor:
                              'rgba(25, 118, 210, 0.08) !important',
                          },
                        },
                        '& img': {
                          display: 'none',
                        },
                        '& .makeStyles-wrapperli-11 > div:nth-of-type(1)': {
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          width: '80%',
                        },
                      },
                    ]}
                    onChange={(e) => {
                      if (e.target.value === '') {
                        setHelperText((pre) => {
                          pre.cpData = false;
                          return { ...pre };
                        });
                      } else {
                        handleChange(e)
                        setCollateralDetails((pre) => {
                          pre.cpData = e.target.value;
                          return { ...pre };
                        });
                        setHelperText((pre) => {
                          pre.cpData = true;
                          return { ...pre };
                        });
                      }
                    }}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.map((m) => m.name).join(', ')


                    }
                    MenuProps={MenuProps}
                  >
                    <MenuItem
                      value='all'
                      sx={[
                        {
                          fontFamily: 'Inter-Medium',
                          fontSize: '1.4rem !important',
                          background: '#FFFfF !important',
                          color: '#101828 !important',
                          borderBottom: '1px solid #F2F4F7 !important',
                          '& ul .MuiList-root-MuiMenu-list': {
                            paddingBottom: '0rem !important',
                          },
                        },
                      ]}
                    >
                      <Checkbox
                        sx={{ transform: 'scale(1.5)' }}
                        checked={isAllSelected}
                        indeterminate={
                          selectedCps.length > 0 &&
                          selectedCps.length < CpNames.length
                        }
                      />

                      <ListItemText
                        className={classList.DropDownName}
                        primary='Select All'
                      />
                    </MenuItem>
                    {CpNames?.map((el, index) => (
                      <MenuItem
                        key={`${el}_${index}`}
                        value={el}
                        sx={[
                          {
                            fontFamily: 'Inter-Medium',
                            fontSize: '1.4rem !important',
                            background: '#FFFfF !important',
                            color: '#101828 !important',
                            borderBottom: '1px solid #F2F4F7 !important',
                            '& ul .MuiList-root-MuiMenu-list': {
                              paddingBottom: '0rem !important',
                            },
                          },
                        ]}
                      >
                        <Checkbox
                          sx={{ transform: 'scale(1.5)' }}
                          checked={selectedCps?.indexOf(el) > -1}
                        />
                        <ListItemText
                          className={classList.DropDownName}
                          primary={el.name}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                  {HelperText?.cpData && (
                    <p
                      style={{
                        color: '#d32f2f',
                        fontSize: '1.4rem',
                        marginLeft: '1rem',
                      }}
                    >
                      {HelperText.cpData}
                    </p>
                  )}
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className={cssClasses.FooterDiv}>
          <Box className={cssClasses.flexRow}>
            <Box width={'fit-Content'} ml={'auto'}>
              <Button
                style={{
                  color: '#344054',
                  backgroundColor: '#ffffff',
                  fontSize: '1.6rem',
                  lineHeight: '2.4rem',
                }}
                padding={'0.85rem 2.6rem'}
                btnName={'Cancel'}
                clicked={handleClose}
              />
            </Box>

            <Box width={'fit-Content'}>
              <Button
                style={{
                  fontSize: '1.6rem',
                  lineHeight: '2.4rem',
                  color: '#ffffff',
                  backgroundColor: '#155EEF',
                }}
                padding={'0.85rem 3rem'}
                disable={CollateralDetails.cpData === []}
                btnName={'Save'}
                clicked={OnSubmit}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddCollateral;
